// extracted by mini-css-extract-plugin
module.exports = {"paginado":"Paginated_paginado__3gvqk","li":"Paginated_li__OgLD_","each":"Paginated_each__lHSCO"};